import { withI18n } from 'react-i18next';
import TrackingFilterBar from './TrackingFilterBar';

export const pureComponent = TrackingFilterBar;
export default withI18n()(TrackingFilterBar);
